// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__3CeYh","link__wrapper":"link_link__wrapper__lKGnH"};